<template>
	<div
		class="sequence-date-cleaner flex sm:items-center justify-center bg-white sm:bg-gray-overlay sm:rounded-2.5xl" 
		@click="$emit('close')"
	>
		<div class="bg-white rounded-2.5xl sm:py-7 sm:px-8" @click.stop>
			<div class="flex justify-between mb-6">
				<div class="font-medium text-lg">
					<p>Confirmer la déprogrammation</p>
				</div>
				<div class="flex-shrink">
					<button class="h-4 w-4 sm:-mr-2" @click="$emit('close')">
						<img src="@/assets/images/cross-icon.svg">
					</button>
				</div>
			</div>

			<div class="mb-10 sm:mb-7">
				<p>
					Toutes les dates associées à ce niveau seront supprimées.
				</p>
				<p>
					Cette action s’appliquera à l’ensemble des dates programmées.
				</p>
			</div>

			<div class="flex justify-center">
				<button
					class="ars-button-blue mr-1"
					:disabled="isLoading"
					@click="$emit('close')"
				>
					Annuler
				</button>
				<button
					class="ars-button-green ml-1"
					:disabled="isLoading"
					@click="onConfirmClick"
				>
					Confirmer
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LevelSequenceDateCleaner',
		props: {
			promotion: {
				type: Object,
				required: true
			},
			remainingScheduledSequences: {
				type: Array,
				required: true
			},
			userSequencesById: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				isLoading: false,
			}
		},
		methods: {
			async onConfirmClick() {
				if (this.isLoading)
					return

				this.isLoading = true

				let error = false

				// Remove all remaining user sequence
				for (var i = 0; i < this.remainingScheduledSequences.length; i++) {
					const id = this.remainingScheduledSequences[i].id
					const userSequence = this.userSequencesById[id]

					if (!userSequence) {
						continue
					}

					// Prepare data
					const data = {
						promotionId: userSequence.promotion_id,
						sequenceId: userSequence.sequence_id,
						startDate: userSequence.start_date,
					}

					let success = null

					try {
						success = await this.$store.dispatch('UserSequence/delete', data)
					} catch (err) {
						success = false
						alert('Erreur : ' + err)
					}

					if (!success) {
						error = true
					}
				}

				// Refresh user sequences
				await this.$store.dispatch('Auth/loadCurrentUserSequences')

				if (error) {
					alert('Erreur lors de la déprogrammation d\'une des séquence.')
				}

				this.isLoading = false

				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss"></style>
